import styled from 'styled-components';

export const Container = styled.ul`
  border-bottom: 1px solid ${({ theme }) => theme.lighterGray};
  margin: 0;
  padding: 0;
  margin-bottom: 15px;
  padding-bottom: 7px;

  li {
    margin-bottom: 8px;
  }
`;
